<template>
    <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                    color="primary"
                    icon
                    dark
                    v-bind="attrs"
                    v-on="on"
                    v-model="$i18n.locale"
            >
                <country-flag :country='currentLanguage'></country-flag>
            </v-btn>
        </template>
        <v-list>
            <v-list-item
                    v-for="(item, index) in langs"
                    :key="index"
                    @click="changeLanguage(item.type)"
            >
                <v-list-item-title>{{ item.type }}</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
    import util from "@/plugins/util";

    export default {
        data() {
            return {
                langs: util.language
            }
        },
        mounted() {
            this.$store.dispatch('loadlLanguage')
        },
        methods: {
            changeLanguage: function (type) {
                this.$store.commit('setLanguage', type)
            }
        },
        computed: {
            currentLanguage: function () {
                return this.$store.getters.getLanguage
            }
        }
    }
</script>